export class CertificadosNacionaisModel {
  id_certificado_nacional: number;
  id_cliente: number = null;
  id_mercadoria: number = null;
  id_variedade: number = null;
  id_assinante: number = null;
  id_assinante2: number = null;
  id_terminal: number = null;
  id_responsavel_coleta: any = '0';
  numero: string;
  responsavel_coleta_nome: string = "O PRÓPRIO REQUISITANTE/INTERESSADO";
  numero_amostra: string;
  peso: any;
  lote: string;
  safra: string;
  forma_acondicionamento: any = [{"texto": null}];
  volumes: string;
  marca_comercial: string;
  procedencia: string;
  tipo_categoria: string  = '';
  natureza_operacao: string = null;
  nota_fiscal: string;
  observacao: string;
  observacaobase: number = 0;
  data_emissao: string;
  indices_conclusao: any;
  data_emissao_analise: string;
  numero_analise: string;
  id_laboratorio: any = 0;
  id_emissor: any = 0;
  id_unidade: number = null;
  emitir_cert_class: boolean = true;
}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/certificados-nacionais.model.ts